import notification from 'antd/lib/notification';
import dayjs from 'dayjs';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ManagerQuery, ScheduleQuery, StoreQuery } from 'renderer/queries';
import { Atoms } from 'renderer/stores';
import { BugsnagService, LambdaClient, uniqBy } from 'renderer/utils';
import { DATE_FORMAT } from 'renderer/constants';
import React from 'react';
import Button from 'antd/lib/button';
export var useNaverBlockingValue = function () {
    var blockingValue = useRecoilValue(Atoms.naverBookingBlockingState);
    return blockingValue;
};
export var useNaverBlockingState = function () {
    var blockingValue = useRecoilValue(Atoms.naverBookingBlockingState);
    return blockingValue;
};
export var useNaverBlocking = function () {
    var _a = useRecoilState(Atoms.naverBookingBlockingState), blockingState = _a[0], setBlockingState = _a[1];
    var status = blockingState.status;
    var startBlocking = function (params) {
        var _a, _b, _c, _d;
        if (params && status !== 'pending') {
            var store_1 = StoreQuery.getMyStoreInCache();
            var managers = ManagerQuery.getManagersInCache();
            var effectedDates_1 = uniqBy((_b = (_a = params.effectedDates) === null || _a === void 0 ? void 0 : _a.filter(Boolean)) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                if (typeof item === 'string') {
                    item = dayjs(item).toDate();
                }
                return item;
            }), function (dateItem) { return dayjs(dateItem).format('YYYYMMDD'); }).filter(function (item) { return !dayjs(item).isBefore(dayjs(), 'date'); }) || [];
            if (effectedDates_1.length === 0) {
                return;
            }
            if (!!((_d = (_c = store_1 === null || store_1 === void 0 ? void 0 : store_1.preference) === null || _c === void 0 ? void 0 : _c.naverSmartPlace) === null || _d === void 0 ? void 0 : _d.isInvalidNaverId)) {
                setStatus('success');
                return notification.error({
                    placement: 'topLeft',
                    message: "\uB124\uC774\uBC84 \uC608\uC57D \uB9C9\uAE30 \uC2E4\uD328",
                    description: '네이버계정에 문제가 있습니다. 고객센터에 연락해서 재연동해주세요.',
                    duration: 0
                });
            }
            setStatus('pending');
            var START_NOTI_1 = 'START_NOTI';
            var effectedDateString_1 = effectedDates_1.map(function (item) { return dayjs(item).format(DATE_FORMAT); }).join(', ');
            if (store_1 === null || store_1 === void 0 ? void 0 : store_1.isOfficialNaver) {
                return LambdaClient.getInstance()
                    .post('/sync/calendar', {
                    storeId: store_1.id,
                    targetDates: effectedDates_1
                })
                    .then(function () {
                    notification.info({
                        placement: 'topLeft',
                        message: "\uB124\uC774\uBC84 \uAC04\uB2E8\uC608\uC57D\uAD00\uB9AC \uB3D9\uAE30\uD654 \uC131\uACF5(".concat(effectedDateString_1),
                        description: '이제 다시 예약을 수정하거나 만들 수 있습니다.'
                    });
                    setStatus('success');
                })
                    .catch(function (err) {
                    notification.destroy(START_NOTI_1);
                    setStatus('failure');
                    var key = "open".concat(Date.now());
                    var btn = (React.createElement(Button, { type: "primary", size: "small", onClick: function () {
                            notification.destroy(key);
                            startBlocking(params);
                        } }, "\uC7AC\uC2DC\uB3C4"));
                    notification.error({
                        key: key,
                        placement: 'topLeft',
                        message: "\uB124\uC774\uBC84 \uAC04\uB2E8\uC608\uC57D\uAD00\uB9AC \uB3D9\uAE30\uD654 \uC2E4\uD328".concat(effectedDateString_1),
                        description: '네이버예약막기를 다시 한번 시도해주세요.',
                        btn: btn,
                        duration: 0
                    });
                });
            }
            notification.info({
                key: START_NOTI_1,
                placement: 'topLeft',
                message: "\uB124\uC774\uBC84 \uC608\uC57D \uB9C9\uAE30 \uC2DC\uC791(".concat(effectedDateString_1, ")"),
                description: "\uB124\uC774\uBC84 \uC608\uC57D \uB9C9\uAE30 \uC791\uC5C5\uB3D9\uC548 \uC608\uC57D\uB4F1\uB85D \uBC0F \uC2DC\uAC04 \uC218\uC815\uC740 \uBD88\uAC00\uB2A5\uD569\uB2C8\uB2E4."
            });
            ScheduleQuery.blockNaverCalendar(effectedDates_1, store_1, managers)
                .then(function (response) {
                notification.destroy(START_NOTI_1);
                setStatus('success');
                notification.info({
                    placement: 'topLeft',
                    message: "\uB124\uC774\uBC84 \uC608\uC57D \uB9C9\uAE30 \uC131\uACF5(".concat(effectedDateString_1),
                    description: '이제 다시 예약을 수정하거나 만들 수 있습니다.'
                });
                if (response && response.data && response.data[0]) {
                }
                else {
                    BugsnagService.getInstance().notify(new Error(JSON.stringify({
                        message: '프론트막기에러-토스트안뜸',
                        effectedDates: effectedDates_1,
                        storeId: store_1.id,
                        name: store_1.name,
                        response: response.data
                    })));
                }
            })
                .catch(function (err) {
                BugsnagService.getInstance().notify(new Error(JSON.stringify({
                    message: '프론트막기에러-토스트안뜸',
                    effectedDates: effectedDates_1,
                    storeId: store_1.id,
                    name: store_1.name,
                    err: err
                })));
            });
        }
    };
    var setStatus = function (status) {
        setBlockingState({
            status: status
        });
    };
    return [status, startBlocking];
};
